import { CrudModel } from "./_crud";

export class QualificationModel extends CrudModel {
	constructor() {
		super("admin/qualification", [], []);
	}
}

export default new QualificationModel();
